module.exports = " <nav class=menu> <ul class=menu-list> <navigation-menu-item v-for=\"item in menu\" :value=item></navigation-menu-item> </ul> </nav> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/app/navigation/NavigationMenu.vue
// module id = 162
// module chunks = 0